// Ballpark Cards: the clickable card stack in the "Experience" section.
// Each click sends the front card to the back of the fan and brings the next one forward.
if (!customElements.get('bp-card-stack')) {
  class BallparkCardStack extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('[data-bp-card]'));
      this.order = this.cards.map((_, index) => index);
      this.button = this.querySelector('[data-bp-stack-button]');
      this.live = this.querySelector('[data-bp-live]');
      this.link = document.getElementById(this.dataset.linkId);
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.busy = false;

      this.render(false);
      if (this.cards.length > 1 && this.button) {
        this.button.addEventListener('click', () => this.next());
      } else if (this.button) {
        this.button.hidden = true;
      }
    }

    next() {
      if (this.busy) return;
      const front = this.cards[this.order[0]];
      const advance = () => {
        front.classList.remove('is-leaving');
        this.order.push(this.order.shift());
        this.render(true);
        this.busy = false;
      };

      if (this.reduceMotion) return advance();
      this.busy = true;
      front.classList.add('is-leaving');
      setTimeout(advance, 260);
    }

    render(announce) {
      this.order.forEach((cardIndex, position) => {
        const card = this.cards[cardIndex];
        card.dataset.pos = position;
        card.setAttribute('aria-hidden', position === 0 ? 'false' : 'true');
      });

      const front = this.cards[this.order[0]];
      if (!front) return;
      if (announce && this.live) this.live.textContent = front.dataset.title;
      if (this.button) {
        this.button.setAttribute('aria-label', `Showing ${front.dataset.title}. Show the next offering`);
      }

      if (this.link) {
        const url = front.dataset.url;
        this.link.hidden = !url;
        if (url) {
          this.link.href = url;
          this.link.textContent = `${front.dataset.linkLabel || front.dataset.title} →`;
        }
      }
    }
  }

  customElements.define('bp-card-stack', BallparkCardStack);
}
